import { createContext } from "react";
import { PremadeTimersService } from "./premadeTimersService";

export const ServicesContext = createContext<{
	premadeTimersService: PremadeTimersService;
}>(null as any);
